import { type PaletteOptions } from '@mui/material/styles'
import { additional } from './light-additional'
import { blue } from './light-blue'
import { green } from './light-green'
import { grey } from './light-grey'
import { opacity } from './light-opacity'
import { postYellow } from './light-post-yellow'
import { pure } from './light-pure'

export const components: PaletteOptions['components'] = {
  avatar: {
    backgroundBlue: additional.vibrandBlue,
    border: grey[400],
  },
  backdrop: {
    fill: opacity.dark[600],
  },
  buttonLink: {
    hover: grey[600],
  },
  chip: {
    icon: opacity.dark[400],
    focus: grey[900],
    border: grey[400],
  },
  dataGrid: {
    zebraDark: grey[200],
    hover: 'rgba(0, 0, 0, 0.10)',
  },
  divider: {
    line: grey[300],
  },
  input: {
    background: pure.light,
  },
  navbar: {
    selected: opacity.primary[100],
    selectedHover: opacity.primary[150],
  },
  pageHeader: {
    default: postYellow[600],
    accept: green[600],
    test: blue[600],
    color: {
      contrast: pure.light,
      default: pure.dark,
    },
  },
  switch: {
    fill: grey[300],
    hover: opacity.dark[50],
    focus: opacity.dark[80],
    border: grey[400],
    knobDisabled: grey[300],
  },
}
